export default __webpack_public_path__ + "5da240ff76e4ed038edd76ee8f436a35.png";